(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/shares.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/shares.js');
"use strict";


const selectShares = state => {
  const _ref = state.Shares || {},
    currentShares = _ref.currentShares,
    offset = _ref.offset,
    count = _ref.count,
    totalHits = _ref.totalHits,
    loading = _ref.loading,
    error = _ref.error,
    hasFetched = _ref.hasFetched;
  return {
    loading,
    currentShares,
    offset,
    count,
    error,
    hasFetched,
    hasMoreData: currentShares.length < totalHits
  };
};
setGlobal('svs.components.marketplaceData.selectors.shares', {
  selectShares
});

 })(window);